// extracted by mini-css-extract-plugin
export default {"cls1":"CNqFMr9NdONwhr7mab9y","cls2":"rqrieYQp8xLczsBGUEzG CNqFMr9NdONwhr7mab9y","isTabletDown":"dnGLGJ2AGH6mucIvO0Sg"};